module.exports = __webpack_public_path__ + "img/phone.01eeedae.jpg";